import { aesPaths } from './paths';

// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog. */
export const serviceScopes = [
  // Pangolin AES Gateway, grouped with Media & Streaming.
  { scope: 'Internal.Aes', category: 'streaming', route: (id: string) => `${aesPaths.base}/${id}` },
] as const;
